import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Dog} from "../../../../../classes/dog";

@Component({
    selector: 'kan-dog-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanDogList {
    @Input() public dogs: Dog[];
    @Input() searchText: string;
    @Input() public loading: boolean = false;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/list/component.ts